/// <reference path="components/external-agent-enrollment/external-agent-step4.component.ts" />
/// <reference path="components/data-entry-enrollment/data-entry-step5.component.ts" />
import { Routes } from '@angular/router'
import { EAppEnrollmentComponent } from '../enrollment/components/e-app-enrollment/e-app-enrollment.component'
import { EAppEnrollmentReadonlyComponent } from './components/e-app-enrollment/e-app-enrollment-readonly.component'
import { EnrollmentLayoutComponent } from '../enrollment/components/layout/enrollment-layout.component'
import { EnrollmentApplicationClientComponent } from './components/common/enrollment-application-client.component'
import { DataEntryStep1Component } from './components/data-entry-enrollment/data-entry-step1.component'
import { DataEntryStep2Component } from './components/data-entry-enrollment/data-entry-step2.component'
import { DataEntryStep3Component } from './components/data-entry-enrollment/data-entry-step3.component'
import { ExternalAgentEnrollmentComponent } from './components/external-agent-enrollment/external-agent-enrollment.component'
import { DataEntryStep4Component } from './components/data-entry-enrollment/data-entry-step4.component'
import { DataEntryStep5Component } from './components/data-entry-enrollment/data-entry-step5.component'
import { EAppStage2EnrollmentComponent } from './components/e-app-stage2-enrollment/e-app-stage2-enrollment.component'
import { ConfirmEnrollmentDetailComponent } from './components/common/confirm-enrollment-detail.component'
import { GroupEnrollmentComponent } from './components/group-enrollment/group-enrollment.component'
import { EAppHistoryComponent } from '../enrollment/components/e-app-enrollment/e-app-history.component'
import { EnrollmentPageComponent } from '../enrollment/components/enrollment-page/enrollment-page.component'
import { Enrollments } from '../enrollment/components/enrollments/enrollments.component'
import { ConfirmationComponent } from './components/data-entry-enrollment/confirmation.component'
import { SendEmailEnrollmentComponent } from './components/send-email-enrollment/Send-EmailEnrollment'

import { EnrollmentMethodAndSoaComponent } from '../enrollment/components/external-agent-enrollment/enrollment-method-and-soa.component'
import { EAppInformationComponent } from './components/e-app-enrollment/e-app-information.component'
import { ExternalAgentStep1 } from './components/external-agent-enrollment/external-agent-step1.component'
import { ExternalAgentStep3 } from './components/external-agent-enrollment/external-agent-step3.component'
import { ExternalAgentStep4 } from './components/external-agent-enrollment/external-agent-step4.component'
import { ExternalAgentStep5 } from './components/external-agent-enrollment/external-agent-step5.component'
import { VerifyEAppComponent } from './components/e-app-enrollment/verify.component'
import { ExternalAgentCheckList } from './components/external-agent-enrollment/external-agent-check-list'
import { EAppEnrollmentButtonComponent } from './components/e-app-enrollment/e-app-enrollmentbutton.component'
import { EAppEnrollmentMessagesComponent } from './components/e-app-enrollment/e-app-enrollmentmessages.component'
import { PrintPdf } from './components/common/print-pdf'

import { PhoneEnrollmentStep1Component } from './components/phone-enrollment/ssi/phone-enrollment-step1.component'
import { PhoneEnrollmentStep2Component } from './components/phone-enrollment/ssi/phone-enrollment-step2.component'
import { PhoneEnrollmentStep3Component } from './components/phone-enrollment/ssi/phone-enrollment-step3.component'
import { PhoneEnrollmentStep4Component } from './components/phone-enrollment/ssi/phone-enrollment-step4.component'
import { PhoneEnrollmentStep5Component } from './components/phone-enrollment/ssi/phone-enrollment-step5.component'
import { PhoneEnrollmentPreviewComponent } from './components/phone-enrollment/ssi/phone-enrollment-preview.component'
import { PhoneEnrollmentConfirmationComponent } from './components/phone-enrollment/ssi/phone-enrollment-confirmation.component'
import { PhoneEnrollmentFinalComponent } from './components/phone-enrollment/ssi/phone-enrollment-final.component'
import { PhoneEnrollmentExtStep1Component } from './components/phone-enrollment/ssi/ext/phone-enrollment-step1.component'
import { PhoneEnrollmentExtStep2Component } from './components/phone-enrollment/ssi/ext/phone-enrollment-step2.component'
import { PhoneEnrollmentExtStep3Component } from './components/phone-enrollment/ssi/ext/phone-enrollment-step3.component'
import { PhoneEnrollmentExtStep4Component } from './components/phone-enrollment/ssi/ext/phone-enrollment-step4.component'
import { PhoneEnrollmentExtStep5Component } from './components/phone-enrollment/ssi/ext/phone-enrollment-step5.component'
import { PhoneEnrollmentExtPreviewComponent } from './components/phone-enrollment/ssi/ext/phone-enrollment-preview.component'
import { PhoneEnrollmentExtConfirmationComponent } from './components/phone-enrollment/ssi/ext/phone-enrollment-confirmation.component'
import { PhoneEnrollmentExtFinalComponent } from './components/phone-enrollment/ssi/ext/phone-enrollment-final.component'
import { BeneficiaryDetailsComponent } from './components/phone-enrollment/ssi/beneficiarydetails.component'
import { ClsIPadHistory } from './components/ipadhistory/ipadhistory-component'
import { ExternalEnrollmentLanding } from './components/ExternalEnrollmentLanding/External-Enrollment-Landing.component'
import { ClsIPadLoginHistory } from './components/ipad-login-history/ipadloginhistory-component'

import { NEJEPhoneEnrollmentStep1Component } from './components/phone-enrollment/neje/phone-enrollment-step1.component'
import { NEJEPhoneEnrollmentStep2Component } from './components/phone-enrollment/neje/phone-enrollment-step2.component'
import { NEJEPhoneEnrollmentStep3Component } from './components/phone-enrollment/neje/phone-enrollment-step3.component'
import { NEJEPhoneEnrollmentPreviewComponent } from './components/phone-enrollment/neje/phone-enrollment-preview.component'
import { NEJEPhoneEnrollmentFinalComponent } from './components/phone-enrollment/neje/phone-enrollment-final.component'
import { NEJEDataEntryStep1Component } from './components/data-entry-enrollment/neje/data-entry-step1.component'
import { NEJEDataEntryStep2Component } from './components/data-entry-enrollment/neje/data-entry-step2.component'
import { NEJEDataEntryStep3Component } from './components/data-entry-enrollment/neje/data-entry-step3.component'
import { NEJEDataEntryStep4Component } from './components/data-entry-enrollment/neje/data-entry-step4.component'
import { NEJEDataEntryStep5Component } from './components/data-entry-enrollment/neje/data-entry-step5.component'
import { NEJEConfirmationComponent } from './components/data-entry-enrollment/neje/confirmation.component'

import { NEJESingleGroupStep1Component } from './components/group-enrollment/neje/single-group-step1.component'
import { NEJESingleGroupStep2Component } from './components/group-enrollment/neje/single-group-step2.component'
import { NEJESingleGroupStep3Component } from './components/group-enrollment/neje/single-group-step3.component'
import { NEJESingleGroupStep4Component } from './components/group-enrollment/neje/single-group-step4.component'
import { NEJESingleGroupStep5Component } from './components/group-enrollment/neje/single-group-step5.component'
import { NEJESingleGroupConfirmationComponent } from './components/group-enrollment/neje/single-group-confirmation.component'

import { PhoneEnrollmentSpanishStep1Component } from './components/phone-enrollment/ssi/spanish/phone-enrollment-step1.component'
import { PhoneEnrollmentSpanishStep2Component } from './components/phone-enrollment/ssi/spanish/phone-enrollment-step2.component'
import { PhoneEnrollmentSpanishStep3Component } from './components/phone-enrollment/ssi/spanish/phone-enrollment-step3.component'
import { PhoneEnrollmentSpanishStep4Component } from './components/phone-enrollment/ssi/spanish/phone-enrollment-step4.component'
import { PhoneEnrollmentSpanishStep5Component } from './components/phone-enrollment/ssi/spanish/phone-enrollment-step5.component'
import { PhoneEnrollmentSpanishPreviewComponent } from './components/phone-enrollment/ssi/spanish/phone-enrollment-preview.component'
import { PhoneEnrollmentSpanishFinalComponent } from './components/phone-enrollment/ssi/spanish/phone-enrollment-final.component'
import { BeneficiaryDetailsSpanishComponent } from './components/phone-enrollment/ssi/spanish/beneficiarydetails.component'
import { CanActivateGaurd } from '../auth/can-activate-gaurd'
import { IndEnrollmentComponent } from './components/ind-enrollment/Ind-Enrollment'

export const routes: Routes = [
    {

        path: '',
        component: EnrollmentLayoutComponent,
        children: [
            {
                path: 'enrollmentInfo',
                component: Enrollments
            },
            {
                path: 'e-app-info',
                canActivate: [CanActivateGaurd],
                component: EAppEnrollmentComponent,
                data: { popUp: 'true' }
            },
            {
                path: 'e-app/:guid',
                component: EAppEnrollmentComponent
            },
            {
                path: 'e-app/:guid/:id',
                component: EAppEnrollmentComponent
            },
            {
                path: 'e-application/verify-application/:guid',
                component: VerifyEAppComponent
            },
            {
                path: 'e-app-info1',
                canActivate: [CanActivateGaurd],
                component: EAppEnrollmentComponent
            },
            {
                path: 'sendEmail',
                canActivate: [CanActivateGaurd],
                component: SendEmailEnrollmentComponent                
            },
            {
                path: 'indEnrollment',
                canActivate: [CanActivateGaurd],
                component: IndEnrollmentComponent
            },
            {
                path: 'e-application/stage2/:id',
                component: EAppStage2EnrollmentComponent
            },
            {
                path: 'e-application/history',
                component: EAppHistoryComponent
            },
            {
                path: 'e-application/confirmation/:id',
                component: EAppEnrollmentButtonComponent
            },
            {
                path: 'e-application/messages/:id',
                component: EAppEnrollmentMessagesComponent
            },
            {
                path: 'external-agent/Step2',
                component: ExternalAgentEnrollmentComponent
            },
            {
                path: 'method-soa',
                component: EnrollmentMethodAndSoaComponent
            },
            {
                path: 'data-entry/Step1',
                canActivate: [CanActivateGaurd],
                component: DataEntryStep1Component
            },
            {
                path: 'data-entry/Step2',
                component: DataEntryStep2Component
            },
            {
                path: 'data-entry/Step3',
                component: DataEntryStep3Component
            },
            {
                path: 'data-entry/Step4',
                component: DataEntryStep4Component
            },
            {
                path: 'data-entry/Step5',
                component: DataEntryStep5Component
            },
            {
                path: 'data-entry/Confrimation',
                component: ConfirmationComponent
            },
            {
                path: 'confirmEnrollmentDetail',
                component: ConfirmEnrollmentDetailComponent
            },
            {
                path: 'groupEnrollment',
                component: GroupEnrollmentComponent
            },
            {
                path: 'enrollmentPage',
                canActivate: [CanActivateGaurd],
                component: EnrollmentPageComponent
            },
            {
                path: 'external-agent/Step1',
                canActivate: [CanActivateGaurd],
                component: ExternalAgentStep1

            },
            {
                path: 'external-agent/Step3',
                component: ExternalAgentStep3
            },
            {
                path: 'external-agent/Step1/:id',
                canActivate: [CanActivateGaurd],
                component: ExternalAgentStep1
            },
            {
                path: 'external-agent/Step1/:id/:from',
                canActivate: [CanActivateGaurd],
                component: ExternalAgentStep1
            },
            {
                path: 'external-agent/Step4',
                component: ExternalAgentStep4

            },
            {
                path: 'external-agent/Step5',
                component: ExternalAgentStep5
            },
            {
                path: 'external-agent/CheckList',
                component: ExternalAgentCheckList
            },
            {
                path: 'print',
                component: PrintPdf
            },


            {
                path: 'phone-enrollment/Step1',
                canActivate: [CanActivateGaurd],
                component: PhoneEnrollmentStep1Component
            },
            {
                path: 'phone-enrollment/Step2',
                component: PhoneEnrollmentStep2Component
            },
            {
                path: 'phone-enrollment/Step3',
                component: PhoneEnrollmentStep3Component
            },
            {
                path: 'phone-enrollment/Step4',
                component: PhoneEnrollmentStep4Component
            },
            {
                path: 'phone-enrollment/Step5',
                component: PhoneEnrollmentStep5Component
            },
            {
                path: 'phone-enrollment/Preview',
                component: PhoneEnrollmentPreviewComponent
            },
            {
                path: 'phone-enrollment/Confirmation',
                component: PhoneEnrollmentConfirmationComponent
            },
            {
                path: 'phone-enrollment/Final',
                component: PhoneEnrollmentFinalComponent
            },
            {
                path: 'phone-enrollment/ext/Step1',
                component: PhoneEnrollmentExtStep1Component
            },
            {
                path: 'phone-enrollment/ext/Step2',
                component: PhoneEnrollmentExtStep2Component
            },
            {
                path: 'phone-enrollment/ext/Step3',
                component: PhoneEnrollmentExtStep3Component
            },
            {
                path: 'phone-enrollment/ext/Step4',
                component: PhoneEnrollmentExtStep4Component
            },
            {
                path: 'phone-enrollment/ext/Step5',
                component: PhoneEnrollmentExtStep5Component
            },
            {
                path: 'phone-enrollment/ext/Preview',
                component: PhoneEnrollmentExtPreviewComponent
            },
            {
                path: 'phone-enrollment/ext/Confirmation',
                component: PhoneEnrollmentExtConfirmationComponent
            },
            {
                path: 'phone-enrollment/ext/Final',
                component: PhoneEnrollmentExtFinalComponent
            },
            {
                path: 'phone-enrollment/BeneficiaryDetails',
                component: BeneficiaryDetailsComponent
            },
            {
                path: 'phone-enrollment/BeneficiaryDetails/:secID',
                component: BeneficiaryDetailsComponent
            },
            {
                path: 'phone-enrollment/Step1/:callLogID/:planyear',
                canActivate: [CanActivateGaurd],
                component: PhoneEnrollmentStep1Component
            }
            ,
            {
                path: 'phone-enrollment/ext/Step1/:callLogID',
                component: PhoneEnrollmentExtStep1Component
            },
            {
                path: 'ipadhistory',
                canActivate: [CanActivateGaurd],
                component: ClsIPadHistory
            },
            {
                path: 'external-enrollment-landing',
                component: ExternalEnrollmentLanding
            },
            {
                path: 'ipadloginhistory',
                canActivate: [CanActivateGaurd],
                component: ClsIPadLoginHistory
            },
            {
                path: 'external-enrollment-landing/:ak/:eid/:selPlanYear',
                component: ExternalEnrollmentLanding
            },
            {
                path: 'e-app-external',
                component: EAppEnrollmentComponent,
                data: { popUp: 'false' }
            },
            {
                path: 'external-agent/Step1/:ak/:eid/:from',
                canActivate: [CanActivateGaurd],
                component: ExternalAgentStep1

            },
            {
                path: 'sendEmail/:email/:selPlanYear',
                canActivate: [CanActivateGaurd],
                component: SendEmailEnrollmentComponent

            },
            {
                path: 'e-app-external/:ak/:eid',
                component: EAppEnrollmentComponent,
                data: { popUp: 'false' }
            },
            {
                path: 'phone-enrollment/ext/Step1/:ak/:eid',
                component: PhoneEnrollmentExtStep1Component

            },
            {
                path: 'neje/phone-enrollment/Step1',
                component: NEJEPhoneEnrollmentStep1Component
            },
            {
                path: 'neje/phone-enrollment/Step2',
                component: NEJEPhoneEnrollmentStep2Component
            },
            {
                path: 'neje/phone-enrollment/Step3',
                component: NEJEPhoneEnrollmentStep3Component
            },
            {
                path: 'neje/phone-enrollment/Preview',
                component: NEJEPhoneEnrollmentPreviewComponent
            },
            {
                path: 'neje/phone-enrollment/Final',
                component: NEJEPhoneEnrollmentFinalComponent
            },
            {
                path: 'neje/data-entry/Step1',
                component: NEJEDataEntryStep1Component
            },
            {
                path: 'neje/data-entry/Step2',
                component: NEJEDataEntryStep2Component
            },
            {
                path: 'neje/data-entry/Step3',
                component: NEJEDataEntryStep3Component
            },
            {
                path: 'neje/data-entry/Step4',
                component: NEJEDataEntryStep4Component
            },
            {
                path: 'neje/data-entry/Step5',
                component: NEJEDataEntryStep5Component
            },
            {
                path: 'neje/data-entry/Confirmation',
                component: NEJEConfirmationComponent
            },
            {
                path: 'neje/single-group/Step1',
                component: NEJESingleGroupStep1Component
            },
            {
                path: 'neje/single-group/Step2',
                component: NEJESingleGroupStep2Component
            },
            {
                path: 'neje/single-group/Step3',
                component: NEJESingleGroupStep3Component
            },
            {
                path: 'neje/single-group/Step4',
                component: NEJESingleGroupStep4Component
            },
            {
                path: 'neje/single-group/Step5',
                component: NEJESingleGroupStep5Component
            },
            {
                path: 'neje/single-group/Confirmation',
                component: NEJESingleGroupConfirmationComponent
            },
            {
                path: 'phone-enrollment/spanish/Step1',
                component: PhoneEnrollmentSpanishStep1Component
            },
            {
                path: 'phone-enrollment/spanish/Step2',
                component: PhoneEnrollmentSpanishStep2Component
            },
            {
                path: 'phone-enrollment/spanish/Step3',
                component: PhoneEnrollmentSpanishStep3Component
            },
            {
                path: 'phone-enrollment/spanish/Step4',
                component: PhoneEnrollmentSpanishStep4Component
            },
            {
                path: 'phone-enrollment/spanish/Step5',
                component: PhoneEnrollmentSpanishStep5Component
            },
            {
                path: 'phone-enrollment/spanish/Preview',
                component: PhoneEnrollmentSpanishPreviewComponent
            },
            {
                path: 'phone-enrollment/spanish/Final',
                component: PhoneEnrollmentSpanishFinalComponent
            },
            {
                path: 'phone-enrollment/spanish/BeneficiaryDetails',
                component: BeneficiaryDetailsSpanishComponent
            },
            {
                path: 'phone-enrollment/spanish/BeneficiaryDetails/:secID',
                component: BeneficiaryDetailsSpanishComponent
            },
            {
                path: 'phone-enrollment/spanish/Step1/:callLogID/:planyear',
                component: PhoneEnrollmentSpanishStep1Component
            }

        ]

    }
]
